import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { RecipeDetail } from '../components/recipes/RecipeDetail';
import { Recipe } from '../types/recipe';
import { recipeApi } from '../services/api';

const RecipeDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [recipe, setRecipe] = React.useState<Recipe | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchRecipe = async () => {
      try {
        if (id) {
          const data = await recipeApi.get(id);
          setRecipe(data);
        }
      } catch (error) {
        console.error('Error fetching recipe:', error);
        navigate('/recipes');
      } finally {
        setLoading(false);
      }
    };

    fetchRecipe();
  }, [id, navigate]);

  if (loading) {
    return <div className="loading">Loading recipe...</div>;
  }

  if (!recipe) {
    return null;
  }

  return (
    <RecipeDetail
      recipe={recipe}
      onEdit={() => navigate(`/recipes/recipe/${recipe.id}/edit`)}
      onDelete={async () => {
        try {
          await recipeApi.delete(recipe.id);
          navigate('/recipes');
        } catch (error) {
          console.error('Error deleting recipe:', error);
        }
      }}
      onBack={() => navigate('/recipes')}
    />
  );
};

export default RecipeDetailPage;
